<template>
<div class="page vh100page">

	<maincontent>
		<template v-slot:content>
			<story :id="id" :fromtime="time" :autoplay="false" :showCourse="true"/>
			<div class="signinwrapper" v-if="!auth">
				<router-link to="/signin">
					<button class="button orange">
						{{$t('app.signinorregistration')}}
					</button>
				</router-link>
			</div>
		</template>
	</maincontent>

</div>
</template>

<style scoped lang="sass">
.signinwrapper
	position: absolute
	z-index: 1
	left : 70px
	right: 70px
	top : calc(2.25 * $r + var(--app-margin-top)) 
	display: flex
	align-items: center
	justify-content: center
</style>

<script>

import story from "@/components/modules/stories/story/index.vue";
import { mapState } from 'vuex';


export default {
	name: 'story_page',
	components: {
		story
	},

	computed: mapState({
		auth : state => state.auth,
        id : function(){
            return this.$route.params.id
        },
		time : function(){
            return Number(this.$route.query.time || '0')
		}
	}),

	methods: {

	},

	mounted() {

	}
}
</script>
